<template>
  <div class="landing_header codered" style="height: 420px!important;">
    <div class="landing_header_bg codered">
      <img :src="contentCloudFront(banner.url)">
    </div>
    <div class="landing_header_content middle">
      <div class="lh_title">{{ banner.banner_title }}</div>
      <div class="lh_sub_title">{{ banner.banner_sub_title }}</div>
      <div class="lh_statistic">
        <div><span style="color:#6c7fb2">${{ tournamentInfo.prize }}</span> PRIZES AWARDED</div>
        <div><span style="color:#6c7fb2">{{ tournamentInfo.total_streamers }}</span> CONTENT CREATORS</div>
        <div><span style="color:#6c7fb2">{{ tournamentInfo.total_users }}</span> ACTIVE PLAYERS</div>
      </div>
      <div class="ls_card" style="display: flex; justify-content: center">
        <div class="left_card">
          <img
            class="lazyload"
            :data-src="contentCloudFrontWithVersion('/' + banner.ava_button1)"
            style="width: 244px;margin: 0 50px;position: relative;max-height: 110px"
          >
          <div class="lh_button lh_button_1">
            <a
              class="landing_btn remove_italic flex_size"
              :href="banner.link_redirect1"
              style="min-width: 244px;background-color: #090a23;pointer-events: none;font-size: 14px; height: 30px"
            >
              <span>{{ banner.ava_title_btn1 }}</span>
            </a>
          </div>
          <div class="lh_button lh_button_2">
            <a
              class="landing_btn remove_italic flex_size"
              :href="banner.link_redirect1"
              :class="{'gray_out' : banner.gray_out_button1}"
              style="min-width: 244px;font-size: 14px; height: 30px"
            >
              <span>{{ banner.text_button1 }}</span>
            </a>
          </div>
          <div class="lh_button lh_button_3">
            <a class="landing_btn remove_italic flex_size" style="min-width: 264px; background-color: unset; color: #6c7fb2;font-size: 12px;pointer-events: none">
              <span>Join 10,000+ Other Creators</span>
            </a>
          </div>
        </div>
        <div class="center_card">
          <img
            class="lazyload"
            :data-src="contentCloudFrontWithVersion('/' + banner['ava_button2'])"
            style="width: 244px;margin: 0 50px;position: relative;max-height: 110px"
          >
          <div class="lh_button lh_button_1">
            <a
              class="landing_btn remove_italic flex_size"
              :href="banner.link_redirect2"
              style="min-width: 244px;background-color: #090a23 ;pointer-events: none; font-size: 14px; height: 30px"
            >
              <span>{{ banner.ava_title_btn2 }}</span>
            </a>
          </div>
          <div class="lh_button lh_button_2">
            <a
              class="landing_btn remove_italic flex_size"
              :class="{'gray_out' : banner.gray_out_button2}"
              :href="banner.link_redirect2"
              style="min-width: 244px;font-size: 14px; height: 30px"
            >
              <span>{{ banner.text_button2 }}</span>
            </a>
          </div>
          <div class="lh_button lh_button_3">
            <a class="landing_btn remove_italic flex_size" style="min-width: 244px; background-color: unset; color: #6c7fb2;font-size: 12px;pointer-events: none">
              <span>Join 250+ Other Esports Orgs</span>
            </a>
          </div>
        </div>
        <div class="right_card">
          <img
            class="lazyload"
            :data-src="contentCloudFrontWithVersion('/' + banner.ava_button3)"
            style="width: 244px;margin: 0 50px;position: relative;max-height: 110px"
          >
          <div class="lh_button lh_button_1">
            <a
              class="landing_btn remove_italic flex_size"
              :href="banner.link_redirect3"
              style="min-width: 244px;background-color: #090a23;pointer-events: none; font-size: 14px; height: 30px"
            >
              <span>{{ banner.ava_title_btn3 }}</span>
            </a>
          </div>
          <div class="lh_button lh_button_2">
            <a
              class="landing_btn remove_italic flex_size"
              :class="{'gray_out' : banner.gray_out_button3}"
              href="banner.link_redirect3"
              target="_blank"
              style="min-width: 244px; font-size: 14px; height: 30px"
            >
              <span>{{ banner.text_button3 }}</span>
            </a>
          </div>
          <div class="lh_button lh_button_3">
            <a class="landing_btn remove_italic flex_size" style="min-width: 220px; background-color: unset; color: #6c7fb2;font-size: 12px;pointer-events: none">
              <span>Join 580+ Colleges</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { component } from '../../../../mixins/component';

export default {
  mixins: [component],
  props: {
    banner: {
      type: Object,
      default() {
        return {
          link_redirect: '',
          url: '',
          show_button1: 0,
          show_button2: 0,
          enable_twitter_cta: 0,
          show_total_registered: 0,
          link_redirect1: '',
          text_button1: '',
          link_redirect2: '',
          text_button2: '',
          total_registered: 0,
        };
      },
    },
    tournamentInfo: {
      type: Object,
      default() {
        return {
          prize: 0,
          total_streamers: 0,
          total_users: 0,
        };
      },
    },
  },
};
</script>
